import {
  ALIGNMENT_DROPDOWN_OPTION_CENTER,
  ALIGNMENT_DROPDOWN_OPTION_LEFT,
  ALIGNMENT_DROPDOWN_OPTION_RIGHT,
  ALIGNMENT_DROPDOWN_OPTION_TEXT_WRAP
} from "./../../../_shared/data-hooks.js";
import { AlignCenterIcon, AlignLeftIcon, AlignRightIcon } from "../../icons/index.js";
const alignmentsMap = {
  LEFT: {
    type: "button",
    text: "AlignObject_Left_Tooltip",
    tooltip: "AlignObject_Left_Tooltip",
    commandKey: "LEFT",
    icon: AlignLeftIcon,
    dataHook: ALIGNMENT_DROPDOWN_OPTION_LEFT
  },
  CENTER: {
    type: "button",
    text: "AlignObject_Center_Tooltip",
    tooltip: "AlignObject_Center_Tooltip",
    commandKey: "CENTER",
    icon: AlignCenterIcon,
    dataHook: ALIGNMENT_DROPDOWN_OPTION_CENTER
  },
  RIGHT: {
    type: "button",
    text: "AlignObject_Right_Tooltip",
    tooltip: "AlignObject_Right_Tooltip",
    commandKey: "RIGHT",
    icon: AlignRightIcon,
    dataHook: ALIGNMENT_DROPDOWN_OPTION_RIGHT
  },
  TEXT_WRAP: {
    type: "toggle",
    text: "TextwrapObject_ToggleButton",
    infoIconTextUnsupportedContainer: "TextwrapObject_ToggleButton_Info_UnsupportedContainer",
    infoIconTextAlignedCenter: "TextwrapObject_ToggleButton_Info_AlignedCenter",
    commandKey: "TEXT_WRAP",
    dataHook: ALIGNMENT_DROPDOWN_OPTION_TEXT_WRAP
  },
  SEPARATOR: {
    type: "divider"
  }
};
const defaultAlignments = [
  alignmentsMap.LEFT,
  alignmentsMap.CENTER,
  alignmentsMap.RIGHT,
  alignmentsMap.SEPARATOR,
  alignmentsMap.TEXT_WRAP
];
export {
  alignmentsMap,
  defaultAlignments
};
//# sourceMappingURL=consts.js.map
